import React, {Component} from "react"
import PropTypes from "prop-types"
import linkify from "linkifyjs/string"
import Button from '../../atoms/Button';
import "./AgendaDay.css"

class AgendaDay extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showDetails: true,
    };
  }

  render() {
    const {items, accommodationRequired, rooms, people, allPeople} = this.props;
    const {showDetails} = this.state;

    // sort by start time
    const itemsSorted = Object.keys(items)
      .map(id => {
        return {
          id,
          ...items[id],
        }
      })
      .sort((a, b) => {
        return a.startTime === b.startTime
          ? 0
          : a.startTime < b.startTime ? -1 : 1
      })

    const peopleList = people.map((personId, index) => {
      const person = allPeople[personId]
      return (
        <span key={personId}>
          {person.name}
          {index < people.length - 1 && ", "}
        </span>
      )
    })

    const toggleDetails = () => {
      this.setState((state) => {
        return {
          showDetails: !state.showDetails
        };
      });
    };

    return (
      <div className="AgendaDay">
        {peopleList.length > 0 &&
          <div className="AgendaDay-People">
            <h4>Attendees</h4>
            <div>
              {peopleList}
            </div>
          </div>}

        <h3> Agenda </h3>
        <div className="AgendaDay-DisplayControls">
          <Button small onClick={toggleDetails} disabled={showDetails}>Show All</Button>
          <Button small onClick={toggleDetails} disabled={!showDetails}>Hide Details</Button>
        </div>
        <div className="AgendaDay-Items">
          {itemsSorted.length > 0
            ? itemsSorted.map(item => {
                return (
                  <div className="AgendaDay-Item" key={item.id}>
                    <h5>
                      <span className="time">
                        {item.startTime}
                        {item.endTime &&
                          item.endTime.length > 0 &&
                          ` to ${item.endTime}`}
                      </span>
                      {item.title}
                    </h5>
                    {showDetails && (
                      <div className="AgendaDay-Item-Details">
                        {item.location &&
                          <div className="location">
                            <small>
                              {item.location}
                            </small>
                          </div>}
                        {item.media &&
                          item.media.url &&
                          <img
                            className="media"
                            src={item.media.url}
                            style={{
                              maxHeight: "170px",
                              maxWidth: "100%",
                            }}
                            alt={item.title}
                          />}
                        {item.description && item.description.length > 0 && (
                          <div>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: item.description
                                  ? linkify(item.description)
                                  : "",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )
              })
            : <p> TBC </p>}
        </div>

        {accommodationRequired &&
          rooms &&
          <div>
            <div className="AgendaDay-Accommodation">
              <h4> Accommodation </h4>
              <div className="AgendaDay-Accommodation-Rooms">
                {Object.keys(rooms).map((roomId, index) => {
                  const room = rooms[roomId]
                  return (
                    <div className="AgendaDay-Room" key={roomId}>
                      <h6>
                        Room #{index + 1}
                      </h6>
                      <ul>
                        {room
                          ? room.map(personId => {
                              return (
                                <li key={personId}>
                                  {" "}{allPeople[personId].name}{" "}
                                </li>
                              )
                            })
                          : null}
                      </ul>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>}
      </div>
    )
  }
}

AgendaDay.defaultProps = {
  items: {},
  accommodationRequired: false,
  rooms: {},
  people: [],
  allPeople: {},
}

AgendaDay.propTypes = {
  date: PropTypes.string,
  items: PropTypes.object.isRequired,
  accommodationRequired: PropTypes.bool.isRequired,
  rooms: PropTypes.object.isRequired,
  people: PropTypes.arrayOf(PropTypes.string),
  allPeople: PropTypes.object.isRequired,
}

export default AgendaDay



// WEBPACK FOOTER //
// ./src/component/organisms/AgendaDay/component.js